import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import ListPharmacyComponents from "../components";
import { getPharmacyList } from "../../../../../services/Handlers/PharmacyService"; // You'll need to create this service
import { useAuth } from "../../../../../context/AuthProvider";
import { PER_PAGE_SIZE } from "../../../../../utils/constants";
import { useHome } from "../../../../../context/HomeProvider";
import { formatTimeToMoment } from "../../../../../utils/utils";
import moment from "moment";

export default function ListPharmacy() {
  const { userDetail } = useAuth();
  const { dataDoctors, refetchDoctors } = useHome();

  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [totalEntries, setTotalEntries] = useState(1);
  const [dataPharmacy, setDataPharmacy] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(PER_PAGE_SIZE);
  const [filterPharmacy, setFilterPharmacy] = useState({
    page: 0,
    size: PER_PAGE_SIZE,
  });

  const { isLoading, isFetching, refetch } = useQuery(
    ["PharmacyList", userDetail?.businessId, page, sizePerPage],
    () =>
      getPharmacyList({
        businessId: userDetail?.businessId,
        page,
        size: sizePerPage,
      }),
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          const response = res?.data?.data || [];
          if (response.length > 0) {
            const data = response.map((item) => ({
              id: item.booking_id,
              visit_id: item.visit_id,
              no_sequence: item?.no_sequence,
              doctorName:
                dataDoctors.find((value) => value.id === item.doctor_id)
                  ?.name || "",
              patient_name: item?.patient_name,
              status: item?.status,
              visit_date:
                formatTimeToMoment(
                  item?.visit_date,
                  "YYYY-MM-DD",
                  "DD MMM YYYY"
                ) || "2023-01-01",
              time_request: item?.updated_at
                ? moment(item?.updated_at).format("DD MMM YYYY, HH:mm")
                : "-",
              visit_time:
                `${formatTimeToMoment(
                  item?.start_visit_time,
                  "HH:mm:ss",
                  "HH:mm"
                )} - ${formatTimeToMoment(
                  item?.end_visit_time,
                  "HH:mm:ss",
                  "HH:mm"
                )}` || "12:00",
              gender: item.gender,
            }));
            setDataPharmacy(data);
          }

          setTotalEntries(res?.data?.total || 0);
          setTotalPage(Math.ceil((res?.data?.total || 0) / sizePerPage));
        }
      },
      enabled: !!userDetail?.businessId,
    }
  );

  useEffect(() => {
    if (userDetail) {
      refetchDoctors();
    }
    //eslint-disable-next-line
  }, [userDetail]);

  const handleChangeFilter = (key, value) => {
    setFilterPharmacy((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleClearFilter = () => {
    setFilterPharmacy({
      page: 0,
      size: sizePerPage,
    });
    setPage(0);
    setTimeout(() => {
      refetch();
    }, 200);
  };

  const handleClickFilter = () => {
    setPage(0);
    refetch();
  };

  const handlePagination = (value) => {
    setPage(value);
  };

  const handleChangeSizePerPage = (size) => {
    setPage(0);
    setSizePerPage(size);
    setFilterPharmacy((prev) => ({
      ...prev,
      size: size,
    }));
  };

  return (
    <ListPharmacyComponents
      handleChangeFilter={handleChangeFilter}
      handleClearFilter={handleClearFilter}
      handleClickFilter={handleClickFilter}
      handlePagination={handlePagination}
      handleChangeSizePerPage={handleChangeSizePerPage}
      isLoading={isLoading || isFetching}
      filterPharmacy={filterPharmacy}
      dataPharmacy={dataPharmacy}
      activePage={page}
      totalPage={totalPage}
      totalEntries={totalEntries}
      sizePerPage={sizePerPage}
    />
  );
}
